export var EBreakpointDevice;
(function (EBreakpointDevice) {
    EBreakpointDevice["MOBILE"] = "MOBILE";
    EBreakpointDevice["TABLET"] = "TABLET";
    EBreakpointDevice["LAPTOP"] = "LAPTOP";
    EBreakpointDevice["DESKTOP"] = "DESKTOP";
    EBreakpointDevice["WIDE"] = "WIDE";
})(EBreakpointDevice || (EBreakpointDevice = {}));
